export default __webpack_public_path__ + "static/media/chinared.bc443b53.jpg";